import React, { useEffect } from 'react';
import styled from 'styled-components';
import { keyframes } from 'styled-components';

const CalendarAIConsultation = () => {
  // Load Calendly widget script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <CalendarContainer>
      <ContentWrapper>
        <CalendarHeader>
          <HeaderTitle>Schedule Your AI Consultation</HeaderTitle>
          <HeaderSubtitle>Select a time that works best for you</HeaderSubtitle>
        </CalendarHeader>
        
        <InfoBox>
          <InfoTitle>About Your Initial Call:</InfoTitle>
          <InfoText>
            This initial call is to discuss your AI project requirements and goals. During this call, we'll assess your needs, 
            answer your questions, and determine how we can best help you. The full consultation can be scheduled immediately 
            after this call or at a later date of your choosing.
          </InfoText>
          <InfoDetails>
            <InfoDetailItem>
              <InfoDetailIcon>⏱️</InfoDetailIcon>
              <InfoDetailText>Duration: 30 minutes</InfoDetailText>
            </InfoDetailItem>
            <InfoDetailItem>
              <InfoDetailIcon>👥</InfoDetailIcon>
              <InfoDetailText>With one of our AI specialists</InfoDetailText>
            </InfoDetailItem>
            <InfoDetailItem>
              <InfoDetailIcon>💬</InfoDetailIcon>
              <InfoDetailText>Via Zoom, Google Meet, or phone</InfoDetailText>
            </InfoDetailItem>
          </InfoDetails>
        </InfoBox>
        
        <CalendlyContainer>
          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/pmteamwinners/30min" 
            style={{ minWidth: '320px', height: '700px' }}
          />
        </CalendlyContainer>
      </ContentWrapper>
    </CalendarContainer>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const CalendarContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(to bottom, #f8f9fa, #e9ecef);
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  
  @media (max-width: 768px) {
    padding: 30px 15px;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1000px;
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 40px;
  animation: ${fadeIn} 0.6s ease forwards;
  
  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const CalendarHeader = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const HeaderTitle = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #024A5F;
  margin-bottom: 10px;
  
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const HeaderSubtitle = styled.p`
  font-size: 18px;
  color: #6c757d;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const InfoBox = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 30px;
  border-left: 4px solid #024A5F;
`;

const InfoTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #024A5F;
  margin-bottom: 15px;
`;

const InfoText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #495057;
  margin-bottom: 20px;
`;

const InfoDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  
  @media (max-width: 576px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const InfoDetailItem = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 200px;
`;

const InfoDetailIcon = styled.span`
  font-size: 24px;
  margin-right: 10px;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const InfoDetailText = styled.span`
  font-size: 15px;
  color: #495057;
`;

const CalendlyContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e9ecef;
`;

export default CalendarAIConsultation; 